export const Denominator = ({ value, record }) => value == null ? '' : Math.round(value*100)/100;
